import { render, staticRenderFns } from "./add-print-goods.vue?vue&type=template&id=1b00ed94&scoped=true&"
import script from "./add-print-goods.vue?vue&type=script&lang=js&"
export * from "./add-print-goods.vue?vue&type=script&lang=js&"
import style0 from "./add-print-goods.vue?vue&type=style&index=0&id=1b00ed94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b00ed94",
  null
  
)

export default component.exports